import React, { Component } from 'react';
import { toast } from 'react-toastify';

import { RetirarMateriaDir } from "../../funciones/EstudiantesFunction";

class MatEstRetiro extends Component {
    state = {
        preloader:{
            icon: "fa fa-circle",
            color: "#9A9A9A" 
        },
        boton:{
            icon: "fa fa-trash",
            text: "Retirar",
            disabled: false
        }
    }

    /* 
    preloader:{
        icon: "fa fa-times",
        color: "#A0555C"
    }
    preloader:{
        icon: "fa fa-check",
        color: "#32704C"

        toast.error(resp.mess, {autoClose: 4000});
    },
    */

    delMat = () => {
        let {data} = this.props;
        if (this.state.boton.disabled === true) return null;

        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A" 
            },
            boton:{
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            RetirarMateriaDir(data.id, () => {
                toast.info("Haz enviado la materia a revisión por administración para su retiro formal", {autoClose: 4000});
                this.props.update()
                this.setState({
                    preloader:{
                        icon: "fa fa-check",
                        color: "#32704C" 
                    },
                    boton:{
                        icon: "fa fa-trash",
                        text: "Retirar",
                        disabled: false
                    }
                })
            })
        })
    }

    render() {
        let {data} = this.props;
        let {preloader, boton} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>{data.materia_name}</td>
                    <td style={styles} align="center">{data.nombre}</td>
                    <td style={styles} align="center">{data.tipoev_name}</td>
                    <td style={styles} align="center">{data.semestre_name}</td>
                    <td style={styles} align="center">
                        <button className="btn btn-primary" onClick={this.delMat} style={{borderWidth: 1}}><i className={boton.icon}></i> {boton.text}</button>
                    </td>
                    <td style={styles} align="center"><i className={preloader.icon} style={{color:preloader.color}}></i></td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default MatEstRetiro;


// WEBPACK FOOTER //
// ./src/views/Registros/MatEstRetiro.jsx